/* =========================================================================
   AGENTLE — Care Guide
   Renders the product / material chooser and each care guide from the
   section's JSON data. Deep links use a bare hash: #mcr, #saffiano …
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- copy ---------- */
  var I18N = {
    en: {
      tabProduct: 'By product', tabMaterial: 'By material',
      askProduct: 'Which piece do you have?', askMaterial: 'Which material is it?',
      bags: 'Bags', wallets: 'Wallets', materials: 'Materials',
      usedIn: 'Used in', back: 'Choose another piece', materialGuide: 'Material guide',
      glance: 'At a glance', care: 'Everyday care', storage: 'Storage', cautions: 'Take care', avoid: "Don'ts",
      sameGuide: 'Same guide for', viewProduct: 'View product', copy: 'Copy link', copied: 'Link copied',
      help: 'Need a hand?', line: 'Chat on LINE', warranty: '15-day warranty', ourMaterials: 'Our materials',
      openLine: 'Open chat', readMore: 'Read more'
    },
    th: {
      tabProduct: 'เลือกตามรุ่น', tabMaterial: 'เลือกตามวัสดุ',
      askProduct: 'คุณใช้รุ่นไหนอยู่', askMaterial: 'สินค้าของคุณเป็นวัสดุอะไร',
      bags: 'กระเป๋า', wallets: 'กระเป๋าสตางค์', materials: 'วัสดุ',
      usedIn: 'ใช้กับ', back: 'เลือกรุ่นอื่น', materialGuide: 'คู่มือตามวัสดุ',
      glance: 'สรุปสั้นๆ', care: 'วิธีดูแลรักษา', storage: 'การจัดเก็บ', cautions: 'ข้อควรระวัง', avoid: 'ข้อห้าม',
      sameGuide: 'ใช้คู่มือเดียวกับ', viewProduct: 'ดูสินค้า', copy: 'คัดลอกลิงก์', copied: 'คัดลอกลิงก์แล้ว',
      help: 'ต้องการความช่วยเหลือ?', line: 'แชทกับเราทาง LINE', warranty: 'รับประกัน 15 วัน', ourMaterials: 'วัสดุของเรา',
      openLine: 'เปิดแชท', readMore: 'อ่านเพิ่มเติม'
    }
  };
  /* Body copy: always follows the storefront language */
  var BODY = {
    en: {
      linePara: 'Send us a photo of a mark or a question about your piece, and our team will tell you how to treat it.',
      warrantyPara: 'Covered against manufacturing defects for 15 days from the day your parcel arrives.',
      materialsPara: 'Why we chose each material, and how it behaves in everyday use.',
      sym: {
        wipe_dry: 'Soft dry cloth', wipe_damp: 'Barely damp cloth', brush: 'Soft brush', shade: 'Store dry, in the shade',
        stuff: 'Fill to keep its shape', no_water: 'Keep away from water', no_rain: 'Not rainproof', no_sun: 'No direct sun',
        no_heat: 'No heat', no_chem: 'No chemicals', no_overload: "Don't overfill", no_wash: 'Do not wash'
      }
    },
    th: {
      linePara: 'ส่งรูปคราบหรือคำถามเกี่ยวกับสินค้าของคุณมาทางแชท ทีมงานจะแนะนำวิธีดูแลที่เหมาะสมให้',
      warrantyPara: 'รับประกันความผิดพลาดจากการผลิต 15 วัน นับจากวันที่ได้รับสินค้า',
      materialsPara: 'ที่มาของวัสดุแต่ละชนิดที่เราเลือกใช้ และคุณสมบัติในการใช้งานจริง',
      sym: {
        wipe_dry: 'เช็ดด้วยผ้านุ่มแห้ง', wipe_damp: 'เช็ดผ้าบิดหมาดได้', brush: 'ปัดด้วยแปรงขนนุ่ม', shade: 'เก็บในที่แห้งและร่ม',
        stuff: 'ใส่ไส้กระดาษคงทรง', no_water: 'ห้ามโดนน้ำ', no_rain: 'ไม่กันฝน', no_sun: 'ห้ามตากแดด',
        no_heat: 'เลี่ยงความร้อน', no_chem: 'ห้ามใช้สารเคมี', no_overload: 'ไม่ใส่ของเกินทรง', no_wash: 'ห้ามซัก'
      }
    }
  };

  /* ---------- icons (24px grid, outline, matches snippets/ag-icon) ---------- */
  var P = {
    cloth: '<path d="M4.5 6.5h11.8l3.2 3.2v8.8h-15z"/><path d="M16.3 6.5v3.2h3.2"/><path d="M7.5 13.6c1.1-.9 2.2-.9 3.3 0s2.2.9 3.3 0"/>',
    clothDamp: '<path d="M3.5 9.5h11v9h-11z"/><path d="M6 14.3c1-.8 2-.8 3 0s2 .8 3 0"/><path d="M18.5 3.8s-2.3 2.6-2.3 4.1a2.3 2.3 0 0 0 4.6 0c0-1.5-2.3-4.1-2.3-4.1Z"/>',
    brush: '<rect x="3.5" y="4.5" width="17" height="5.5" rx="2.75"/><path d="M6.5 10v7.5M9.5 10v8.5M12.5 10v8.5M15.5 10v8.5M18 10v7.5"/>',
    house: '<path d="M3.5 10.5 12 4l8.5 6.5"/><path d="M5.5 9v10.5h13V9"/><path d="M9.5 19.5v-5h5v5"/>',
    stuff: '<path d="M4.5 9.5h15l-1.2 10.5H5.7z"/><path d="M8.5 9.5V7.6a3.5 3.5 0 0 1 7 0v1.9"/><path d="M7.5 14.2l1.8 1.3 1.8-1.3 1.8 1.3 1.8-1.3 1.8 1.3"/>',
    drop: '<path d="M12 3.5s-6 6.6-6 10.6a6 6 0 0 0 12 0c0-4-6-10.6-6-10.6Z"/>',
    rain: '<path d="M7.2 15A4 4 0 0 1 7 7a5.5 5.5 0 0 1 10.4 1.3A3.4 3.4 0 0 1 17.2 15Z"/><path d="m8.8 18-1 2.4M12.6 18l-1 2.4M16.4 18l-1 2.4"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.8v2.2M12 19v2.2M2.8 12H5M19 12h2.2M5.5 5.5 7 7M17 17l1.5 1.5M5.5 18.5 7 17M17 7l1.5-1.5"/>',
    flame: '<path d="M12 21a6 6 0 0 0 6-6c0-3.5-2.4-5.6-3.5-8.6-1 2-2 2.6-2.6 2.6.2-2.5-.8-4.4-2.4-6 .3 3.2-3.5 6-3.5 12a6 6 0 0 0 6 6Z"/>',
    flask: '<path d="M9.5 3.5h5M10.5 3.5v5.3L5.3 18.2A1.6 1.6 0 0 0 6.7 20.5h10.6a1.6 1.6 0 0 0 1.4-2.3L13.5 8.8V3.5"/><path d="M7.7 14.6h8.6"/>',
    weight: '<path d="M7 9.5h10l2.3 10.5H4.7z"/><path d="M9.6 9.5a2.4 2.4 0 1 1 4.8 0"/>',
    basin: '<path d="M3.3 7.5 5.3 19h13.4l2-11.5"/><path d="M4.1 11.6c1.5 1 2.7 1 4 0s2.6-1 4 0 2.6 1 4 0 2.4-1 3.7-.2"/>',
    alert: '<path d="M12 4 2.9 19.5h18.2Z"/><path d="M12 10v4.4M12 17v.1"/>',
    ban: '<circle cx="12" cy="12" r="8.5"/><path d="m6 6 12 12"/>',
    check: '<path d="m5 12.5 4.3 4.3L19 7"/>',
    x: '<path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/>',
    arrowR: '<path d="M3 12h17M14.5 6.5 20 12l-5.5 5.5"/>',
    chevL: '<path d="m15 6-6 6 6 6"/>',
    link: '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>',
    shield: '<path d="M12 2.8 4.5 5.6v6c0 4.6 3.1 8.2 7.5 9.6 4.4-1.4 7.5-5 7.5-9.6v-6L12 2.8Z"/><path d="m8.8 12 2.2 2.2 4.3-4.4"/>',
    feather: '<path d="M20 4c-6.5 0-12 4.6-12 11.5V20"/><path d="M8 15.5c4.7 0 8.6-1.9 11-6.5M4 20h8"/>',
    chat: '<path d="M4 5.5h16v11H9.5L5.5 20v-3.5H4z"/><path d="M8 10.5h8M8 13.5h5"/>',
    /* swatches */
    smooth: '<rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/><path d="M7 15.5 15.5 7M10 17.5l7.5-7.5" opacity=".6"/>',
    saffiano: '<rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/><g opacity=".55" stroke-width=".9"><path d="M3.5 8.5l5-5M3.5 13.5l10-10M3.5 18.5l15-15M6.5 20.5l14-14M11.5 20.5l9-9M16.5 20.5l4-4"/><path d="M3.5 3.5l17 17M3.5 8.5l12 12M3.5 13.5l7 7M8.5 3.5l12 12M13.5 3.5l7 7"/></g>',
    pebbled: '<rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/><g opacity=".7" stroke-width="1"><circle cx="7.6" cy="7.8" r="1.5"/><circle cx="12.2" cy="7.2" r="1.3"/><circle cx="16.6" cy="8" r="1.5"/><circle cx="8.1" cy="12.4" r="1.3"/><circle cx="12.6" cy="12.2" r="1.6"/><circle cx="16.8" cy="12.6" r="1.2"/><circle cx="7.6" cy="16.6" r="1.5"/><circle cx="12" cy="16.8" r="1.2"/><circle cx="16.4" cy="16.6" r="1.5"/></g>',
    canvas: '<rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/><path d="M3.5 8h17M3.5 12h17M3.5 16h17M8 3.5v17M12 3.5v17M16 3.5v17" opacity=".45" stroke-width=".9"/>'
  };
  var SYM = {
    wipe_dry: ['cloth', 0], wipe_damp: ['clothDamp', 0], brush: ['brush', 0], shade: ['house', 0], stuff: ['stuff', 0],
    no_water: ['drop', 1], no_rain: ['rain', 1], no_sun: ['sun', 1], no_heat: ['flame', 1], no_chem: ['flask', 1],
    no_overload: ['weight', 1], no_wash: ['basin', 1]
  };
  function svg(name, size, sw, extra) {
    return '<svg class="ag-i agc-i" width="' + (size || 20) + '" height="' + (size || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
      (sw || 1.3) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (P[name] || '') + (extra || '') + '</svg>';
  }
  /* "not allowed" variant: the icon with a slash that has a paper-coloured halo */
  var SLASH = '<path class="agc-halo" d="M4 4l16 16" stroke-width="3.6"/><path d="M4 4l16 16"/>';

  /* ---------- product sketches (no-photo fallback) ---------- */
  var SHAPES = {
    crossbody: '<path d="M32 53c1-30 55-30 56 0"/><rect x="25" y="52" width="70" height="42" rx="7"/><path d="M25 61h70"/><path d="M54 77h12"/>',
    pouch: '<rect x="20" y="56" width="74" height="36" rx="9"/><path d="M20 64h74"/><path d="M94 61c11 0 14-15 5-22s-20 2-16 17"/><path d="M50 78h14"/>',
    box: '<path d="M26 46h56v48H26z"/><path d="M82 46l12-8v48l-12 8"/><path d="M26 46l12-8h56"/><path d="M30 46c-1-30 58-36 62-10"/><path d="M48 70h12"/>',
    clutch: '<rect x="14" y="44" width="90" height="48" rx="4"/><path d="M14 53h90"/><path d="M104 60h5a6 6 0 0 1 0 14h-5"/><path d="M52 74h14"/>',
    briefcase: '<rect x="11" y="44" width="98" height="52" rx="5"/><path d="M45 44v-7a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v7"/><path d="M11 64h98"/><path d="M54 64v5h12v-5"/>',
    cardcase: '<rect x="30" y="46" width="60" height="46" rx="5"/><path d="M38 46V33a2 2 0 0 1 2-2h34a2 2 0 0 1 2 2v13"/><path d="M45 31v-6a2 2 0 0 1 2-2h33a2 2 0 0 1 2 2v21"/><path d="M52 23v-5a2 2 0 0 1 2-2h32a2 2 0 0 1 2 2v28"/><circle cx="60" cy="74" r="5"/>',
    slim: '<rect x="22" y="38" width="76" height="50" rx="5"/><path d="M60 38v50" stroke-dasharray="2 4"/><path d="M30 38v-6h24v6"/><path d="M84 58h6"/>',
    bifold: '<rect x="20" y="40" width="72" height="48" rx="5"/><path d="M84 56h14a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H84"/><path d="M20 50h72" opacity=".55"/><circle cx="94" cy="65" r="2"/>',
    passport: '<rect x="35" y="20" width="52" height="78" rx="5"/><path d="M42 20v78"/><circle cx="63" cy="52" r="9"/><path d="M54 52h18M63 43c-4 5-4 13 0 18M63 43c4 5 4 13 0 18"/><path d="M55 76h16"/>'
  };
  function sketch(shape) {
    return '<svg class="agc-sketch" viewBox="0 0 120 120" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      (SHAPES[shape] || SHAPES.crossbody) + '</svg>';
  }

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function lines(s) {
    return String(s || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function pick(o, base, lang) {
    var th = o[base + '_th'];
    return lang === 'th' && th ? th : (o[base] || th || '');
  }

  /* ---------- app ---------- */
  function CareGuide(root) {
    var dataEl = root.querySelector('[data-agc-data]');
    var app = root.querySelector('[data-agc-app]');
    if (!dataEl || !app || root.__agc) return;
    root.__agc = this;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var self = this;
    this.root = root; this.app = app; this.data = data;
    this.mats = {}; (data.materials || []).forEach(function (m) { if (m.key) self.mats[m.key] = m; });
    this.prods = (data.products || []).filter(function (p) { return p.key && self.mats[p.material]; });
    this.byKey = {}; this.prods.forEach(function (p) { self.byKey[p.key] = p; });
    this.mode = 'product';
    this.depth = 0;
    this.lang();
    /* history: our own links push an entry carrying their depth; Back/Forward pop it */
    window.addEventListener('popstate', function (e) {
      self.depth = (e.state && e.state.agcd) || 0;
      self.route(true);
    });
    window.addEventListener('hashchange', function () { if (self.key() !== self.cur) self.route(true); });
    root.addEventListener('click', function (e) { self.click(e); });
    this.route(false);
    this.baseChooser = this.view && this.view.type === 'chooser';
  }

  CareGuide.prototype.go = function (key) {
    this.depth += 1;
    try { history.pushState({ agcd: this.depth }, '', '#' + key); }
    catch (e) { location.hash = key; return; }
    this.route(true);
  };

  CareGuide.prototype.lang = function () {
    this.hl = this.root.getAttribute('data-head') === 'th' ? 'th' : 'en';
    this.bl = this.root.getAttribute('data-body') === 'th' ? 'th' : 'en';
    this.T = I18N[this.hl]; this.B = BODY[this.bl];
  };
  CareGuide.prototype.refresh = function () { this.lang(); this.route(false); };

  CareGuide.prototype.key = function () {
    var h = (location.hash || '').replace(/^#/, '');
    try { h = decodeURIComponent(h); } catch (e) {}
    return h.toLowerCase();
  };

  CareGuide.prototype.route = function (fromNav) {
    var k = this.key();
    var view;
    if (this.byKey[k]) view = { type: 'product', p: this.byKey[k], m: this.mats[this.byKey[k].material] };
    else if (this.mats[k]) view = { type: 'material', m: this.mats[k] };
    else if (k === 'by-material') { this.mode = 'material'; view = { type: 'chooser' }; }
    else if (k === '' || k === 'by-product') { if (k) this.mode = 'product'; view = { type: 'chooser' }; }
    else return; /* unrelated hash (e.g. #MainContent): leave the page as it is */
    this.cur = k;
    this.view = view;
    this.app.innerHTML = view.type === 'chooser' ? this.chooser() : this.guide(view);
    this.app.setAttribute('data-view', view.type);
    if (fromNav) this.settle(view.type !== 'chooser');
  };

  CareGuide.prototype.settle = function (focusTitle) {
    var top = this.app.getBoundingClientRect().top + window.pageYOffset;
    var hdr = document.querySelector('.ag-hdr');
    var off = (hdr ? hdr.getBoundingClientRect().height : 0) + 16;
    if (Math.abs(window.pageYOffset - (top - off)) > 40 || window.pageYOffset > top) {
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      try { window.scrollTo({ top: Math.max(0, top - off), behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { window.scrollTo(0, Math.max(0, top - off)); }
    }
    var t = this.app.querySelector(focusTitle ? '.agc-hero__t' : '.agc-tab[aria-selected="true"]');
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
  };

  CareGuide.prototype.click = function (e) {
    var tab = e.target.closest('.agc-tab');
    if (tab) {
      this.mode = tab.getAttribute('data-mode');
      this.app.innerHTML = this.chooser();
      var sel = this.app.querySelector('.agc-tab[aria-selected="true"]');
      if (sel) sel.focus();
      return;
    }
    var back = e.target.closest('[data-agc-back]');
    if (back) {
      e.preventDefault();
      if (this.baseChooser && this.depth > 0) { history.go(-this.depth); }
      else { this.go(this.view && this.view.type === 'material' ? 'by-material' : 'by-product'); }
      return;
    }
    var copy = e.target.closest('[data-agc-copy]');
    if (copy) { this.copy(copy); return; }
    var a = e.target.closest('a[href^="#"]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      var k = a.getAttribute('href').slice(1).toLowerCase();
      if (this.byKey[k] || this.mats[k]) {
        e.preventDefault();
        if (this.mats[k]) this.mode = 'material';
        this.go(k);
      }
    }
  };

  CareGuide.prototype.copy = function (btn) {
    var url = location.href;
    var T = this.T, label = btn.querySelector('span');
    function done() { if (label) { label.textContent = T.copied; setTimeout(function () { label.textContent = T.copy; }, 1800); } }
    function fallback() {
      var i = document.createElement('input'); i.value = url; i.setAttribute('readonly', '');
      i.style.position = 'fixed'; i.style.opacity = '0'; document.body.appendChild(i); i.select();
      try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(i);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fallback);
      else fallback();
    } catch (e) { fallback(); }
  };

  /* ---------- views ---------- */
  CareGuide.prototype.matName = function (m) { return pick(m, 'name', this.hl); };

  CareGuide.prototype.media = function (p, cls) {
    var sk = sketch(p.shape);
    if (!p.img) return '<span class="' + cls + ' is-sketch">' + sk + '</span>';
    return '<span class="' + cls + '" data-sk="' + esc(sk) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="640" height="640" ' +
      'onerror="var s=this.parentNode;s.classList.add(\'is-sketch\');s.innerHTML=s.getAttribute(\'data-sk\')"></span>';
  };

  CareGuide.prototype.chooser = function () {
    var T = this.T, self = this, isMat = this.mode === 'material';
    var h = '<div class="agc-bar">' +
      '<p class="agc-bar__q">' + esc(isMat ? T.askMaterial : T.askProduct) + '</p>' +
      '<div class="agc-tabs" role="tablist" aria-label="' + esc(T.askProduct) + '">' +
      '<button type="button" class="agc-tab" role="tab" data-mode="product" aria-selected="' + !isMat + '">' + svg('stuff', 18, 1.5) + '<span>' + esc(T.tabProduct) + '</span></button>' +
      '<button type="button" class="agc-tab" role="tab" data-mode="material" aria-selected="' + isMat + '">' + svg('saffiano', 18, 1.4) + '<span>' + esc(T.tabMaterial) + '</span></button>' +
      '</div></div><div class="agc-panel agc-in" role="tabpanel">';
    if (!isMat) {
      ['bags', 'wallets'].forEach(function (g) {
        var list = self.prods.filter(function (p) { return p.group === g; });
        if (!list.length) return;
        h += '<section class="agc-group"><h2 class="agc-group__h">' + esc(T[g]) + '<span>' + list.length + '</span></h2><div class="agc-grid">';
        list.forEach(function (p) {
          var m = self.mats[p.material];
          h += '<a class="agc-tile" href="#' + esc(p.key) + '">' + self.media(p, 'agc-tile__img') +
            '<span class="agc-tile__t">' + esc(p.title) + '</span>' +
            '<span class="agc-tile__m">' + esc(self.matName(m)) + '</span></a>';
        });
        h += '</div></section>';
      });
    } else {
      h += '<div class="agc-mats">';
      Object.keys(this.mats).forEach(function (k) {
        var m = self.mats[k];
        var used = self.prods.filter(function (p) { return p.material === k; }).map(function (p) { return p.title; });
        h += '<a class="agc-mat" href="#' + esc(k) + '">' +
          '<span class="agc-mat__sw agc-sw agc-sw--' + esc(m.swatch || 'smooth') + '" aria-hidden="true"></span>' +
          '<span class="agc-mat__body"><span class="agc-mat__t">' + esc(self.matName(m)) + '</span>' +
          '<span class="agc-mat__p">' + esc(pick(m, 'intro', self.bl)) + '</span>' +
          (used.length ? '<span class="agc-mat__u"><b>' + esc(T.usedIn) + '</b> ' + esc(used.join(' · ')) + '</span>' : '') +
          '</span><span class="agc-mat__go">' + svg('arrowR', 20, 1.5) + '</span></a>';
      });
      h += '</div>';
    }
    return h + '</div>' + this.help();
  };

  CareGuide.prototype.guide = function (v) {
    var T = this.T, B = this.B, bl = this.bl, self = this, m = v.m, p = v.p;
    var siblings = this.prods.filter(function (x) { return x.material === m.key && (!p || x.key !== p.key); });
    var h = '<div class="agc-guide agc-in">';
    h += '<a class="agc-back" href="#by-' + (p ? 'product' : 'material') + '" data-agc-back>' + svg('chevL', 18, 1.8) + '<span>' + esc(T.back) + '</span></a>';

    /* hero */
    h += '<header class="agc-hero">';
    if (p) h += this.media(p, 'agc-hero__media');
    else h += '<span class="agc-hero__media is-swatch agc-sw agc-sw--' + esc(m.swatch || 'smooth') + '" aria-hidden="true"></span>';
    h += '<div class="agc-hero__info">' +
      '<span class="ag-eyebrow">' + esc(p ? this.matName(m) : T.materialGuide) + '</span>' +
      '<h2 class="agc-hero__t" tabindex="-1">' + esc(p ? p.title : this.matName(m)) + '</h2>';
    if (p && pick(p, 'note', bl)) h += '<p class="agc-hero__note">' + esc(pick(p, 'note', bl)) + '</p>';
    h += '<p class="agc-hero__intro">' + esc(pick(m, 'intro', bl)) + '</p>';
    if (siblings.length) {
      h += '<div class="agc-also"><span class="agc-also__l">' + esc(p ? T.sameGuide : T.usedIn) + '</span>';
      siblings.forEach(function (x) { h += '<a class="agc-chip" href="#' + esc(x.key) + '">' + esc(x.title) + '</a>'; });
      h += '</div>';
    }
    h += '<div class="agc-hero__actions">';
    if (p && p.url) h += '<a class="ag-link" href="' + esc(p.url) + '">' + esc(T.viewProduct) + ' ' + svg('arrowR', 18, 1.5) + '</a>';
    h += '<button type="button" class="agc-copy" data-agc-copy>' + svg('link', 18, 1.5) + '<span>' + esc(T.copy) + '</span></button>';
    h += '</div></div></header>';

    /* at a glance */
    var syms = (m.symbols || []).filter(function (s) { return SYM[s]; });
    if (syms.length) {
      var cm = syms.length <= 6 ? 3 : 4;
      h += '<section class="agc-glance" aria-label="' + esc(T.glance) + '"><h3 class="agc-h agc-h--sm">' + esc(T.glance) + '</h3>' +
        '<ul class="agc-syms" role="list" style="--cm:' + cm + ';--cd:' + syms.length + '">';
      syms.forEach(function (s) {
        var d = SYM[s];
        h += '<li class="agc-sym' + (d[1] ? ' is-no' : '') + '">' + svg(d[0], 36, 1.2, d[1] ? SLASH : '') + '<span>' + esc(B.sym[s]) + '</span></li>';
      });
      h += '</ul></section>';
    }

    /* callout */
    var ct = pick(m, 'callout_title', bl), cb = pick(m, 'callout', bl);
    if (ct || cb) {
      h += '<aside class="agc-callout"><span class="agc-callout__i">' + svg(m.key === 'topgrain' ? 'drop' : 'rain', 30, 1.3) + '</span><div>' +
        (ct ? '<h3 class="agc-callout__t">' + esc(ct) + '</h3>' : '') + (cb ? '<p class="agc-callout__p">' + esc(cb) + '</p>' : '') + '</div></aside>';
    }

    /* care + storage */
    function list(items, icon, cls) {
      return '<ul class="agc-list ' + cls + '" role="list">' + items.map(function (t) {
        return '<li>' + svg(icon, 18, 1.8) + '<span>' + esc(t) + '</span></li>';
      }).join('') + '</ul>';
    }
    var care = lines(pick(m, 'care', bl)), store = lines(pick(m, 'storage', bl));
    if (care.length || store.length) {
      h += '<div class="agc-cols">';
      if (care.length) h += '<section class="agc-sec"><h3 class="agc-h">' + svg('cloth', 26) + esc(T.care) + '</h3>' + list(care, 'check', 'agc-list--ok') + '</section>';
      if (store.length) h += '<section class="agc-sec"><h3 class="agc-h">' + svg('house', 26) + esc(T.storage) + '</h3>' + list(store, 'check', 'agc-list--ok') + '</section>';
      h += '</div>';
    }

    /* cautions */
    var cautions = lines(pick(m, 'cautions', bl));
    if (cautions.length) {
      h += '<section class="agc-sec agc-wide"><h3 class="agc-h">' + svg('alert', 26) + esc(T.cautions) + '</h3><div class="agc-cautions">';
      cautions.forEach(function (c) {
        var parts = c.split('::'), t = parts.length > 1 ? parts.shift().trim() : '', body = parts.join('::').trim();
        h += '<div class="agc-caution">' + (t ? '<h4>' + esc(t) + '</h4>' : '') + (body ? '<p>' + esc(body) + '</p>' : '') + '</div>';
      });
      h += '</div></section>';
    }

    /* don'ts */
    var avoid = lines(pick(m, 'avoid', bl));
    if (avoid.length) h += '<section class="agc-sec agc-wide"><h3 class="agc-h">' + svg('ban', 26) + esc(T.avoid) + '</h3>' + list(avoid, 'x', 'agc-list--no agc-list--2') + '</section>';

    h += '</div>';
    return h + this.help();
  };

  CareGuide.prototype.help = function () {
    var T = this.T, B = this.B, L = this.data.links || {};
    var items = [];
    if (L.line) items.push(['chat', T.line, B.linePara, L.line, T.openLine]);
    if (L.warranty) items.push(['shield', T.warranty, B.warrantyPara, L.warranty, T.readMore]);
    if (L.materials) items.push(['feather', T.ourMaterials, B.materialsPara, L.materials, T.readMore]);
    if (!items.length) return '';
    var h = '<section class="agc-help" aria-label="' + esc(T.help) + '"><div class="ag-if__grid" style="--cols:' + items.length + '">';
    items.forEach(function (it) {
      h += '<div class="ag-if__item"><span class="ag-if__icon">' + svg(it[0], 42) + '</span>' +
        '<h3 class="ag-if__t">' + esc(it[1]) + '</h3><p class="ag-if__p">' + esc(it[2]) + '</p>' +
        '<a class="ag-if__a" href="' + esc(it[3]) + '"' + (/^https?:/.test(it[3]) ? ' target="_blank" rel="noopener"' : '') + '>' + esc(it[4]) + '</a></div>';
    });
    return h + '</div></section>';
  };

  /* ---------- boot ---------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-agc]').forEach(function (el) { new CareGuide(el); });
  }
  window.AgCareGuide = { boot: boot, refresh: function () {
    document.querySelectorAll('[data-agc]').forEach(function (el) { if (el.__agc) el.__agc.refresh(); });
  } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
